/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarkAuctionPaymentProcessStatus } from '../../models/mark-auction-payment-process-status';

export interface MarkAuctionAsFullyPayed$Params {
  auctionId: number;
  'X-API-Version'?: string;
}

export function markAuctionAsFullyPayed(http: HttpClient, rootUrl: string, params: MarkAuctionAsFullyPayed$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkAuctionPaymentProcessStatus>> {
  const rb = new RequestBuilder(rootUrl, markAuctionAsFullyPayed.PATH, 'post');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarkAuctionPaymentProcessStatus>;
    })
  );
}

markAuctionAsFullyPayed.PATH = '/api/auction-payments/{auctionId}';
